import {
  getRequest,
  postRequest,
  postRequestByJson,
  putRequest,
  deleteRequest,
  uploadFileRequest,
} from "@/libs/axios";
import { Message } from "element-ui";

function myThen(data) {
  try {
    if (data.code == 200) {
      return Promise.resolve(data.data);
    } else {
      Message.error(data.info);
      return Promise.reject(data.info);
    }
  } catch (e) {
    return Promise.reject(data);
  }
}

export const getPreviousCertificateList = (params) => {
  return postRequest(
    "/base/usercertificatecheck/haveCertificateList",
    params
  ).then(myThen);
};

export const CertificateTransformList = (params) => {
  return postRequest(
    "/base/usercertificate/userChangeCertificateList",
    params
  ).then(myThen);
};

//证书转换审核通过
export const certificateTransformAudit = (params) => {
  return postRequest(
    "/base/usercertificatecheck/conversionCertificateReview",
    params
  );
};
export const certificateAuditList = (params) => {
  return postRequest("base/usercertificateaudit/list", params).then(myThen);
};

export const certificateAudit = (params) => {
  return postRequest("/base/usercertificateaudit/editAudit", params);
};
//证书转换记录导出
export const exportCertificateTransform = (params) => {
  return getRequest("/base/common/userChangeCertificateListExport", params);
};
export const certificateBatchAudit = (params) => {
  return postRequest("/base/usercertificateaudit/addAuditBatch", params);
};
// 预览证书
export const previewCertificate = (params) => {
  return postRequest("/base/usercertificateaudit/preview", params);
};
// 颁发证书
export const awardCertificate = (params) => {
  return postRequest("/base/usercertificateaudit/batchAward1", params);
};
// 证书盖章
export const sealCertificate = (params) => {
  return postRequest("/base/usercertificateaudit/batchSign", params);
};
// 删除证书申请
export const deleteCertificateAudit = (params) => {
  return postRequest("/base/usercertificateaudit/delAuditBatch", params);
};
// 证书审核日志
export const getCertificateAuditLog = (params) => {
  return postRequest("/base/usercertificateaudit/auditRecordDetail", params);
};
// 1+x证书审核列表
export const getOneplusxAuditList = (params) => {
  return postRequest("/base/onePlusX/pageList", params).then(myThen);
};

// 1+x证书审核
export const oneplusxAudit = (params) => {
  return postRequest("/base/onePlusX/edit", params).then(myThen);
};
